module.exports = __webpack_public_path__ + "media/images/links_to_banks_on_success_page/ACB-12469f7e25d8c9f5606cf2952c2a229d.png";